import { moveAsset } from './moveAsset';
import { UNASSIGNED_BUCKET_INDEX } from '../AssetBucketingEdit.meta';
import { AssetDTO, BucketDTO } from '../api/useAssetBucketingDetailsQuery';

interface RemoveBucketsParams {
  bucketsToRemoveCount: number;
  buckets: BucketDTO[];
  unassignedAssets: AssetDTO[];
}

export const removeBuckets = ({
  bucketsToRemoveCount,
  buckets,
  unassignedAssets,
}: RemoveBucketsParams) => {
  let bucketsCopy = [...buckets];
  let unassignedAssetsCopy = [...unassignedAssets];

  for (let i = buckets.length - 1; i >= buckets.length - bucketsToRemoveCount; i -= 1) {
    const bucketToRemove = bucketsCopy[i];

    if (bucketToRemove.assets.length > 0) {
      for (let j = 0; j < bucketToRemove.assets.length; j += 1) {
        const asset = bucketToRemove.assets[j];

        const result = moveAsset({
          assetId: asset.id,
          sourceBucketIndex: i,
          destinationBucketIndex: UNASSIGNED_BUCKET_INDEX,
          buckets: bucketsCopy,
          unassignedAssets: unassignedAssetsCopy,
        });

        bucketsCopy = result.buckets;
        unassignedAssetsCopy = result.unassignedAssets;
      }
    }

    bucketsCopy.pop();
  }

  return {
    buckets: bucketsCopy,
    unassignedAssets: unassignedAssetsCopy,
  };
};
